import axiosConfig from "./axiosConfig";

// One rule-level change between two revisions. `fields_changed` lists which of
// the rule's fields moved (for the "changed"/"status" kinds).
export interface PromptRuleChange {
  rule_id: string;
  title: string;
  kind: "added" | "removed" | "changed" | "status" | "reordered";
  fields_changed: string[];
  detail: string;
}

export interface LandlordPromptDiffResponse {
  fromRevision: number;
  toRevision: number;
  preambleChanged: boolean;
  // Rule-level diff: which rules moved and which of their fields.
  ruleChanges: PromptRuleChange[];
  // Character-level unified diff of the two compiled prompts.
  textDiff: string[];
}

const getLandlordResearchPromptDiff = async (
  authToken: string,
  fromRevision: number,
  toRevision: number
): Promise<LandlordPromptDiffResponse> => {
  const { data } = await axiosConfig.get(
    `/leads/ai-prompt/diff`,
    {
      params: { task: "landlord_research", from: fromRevision, to: toRevision },
      headers: { Authorization: `Bearer ${authToken}` },
    }
  );
  return data;
};

export default getLandlordResearchPromptDiff;
